import { AddToCartProcessStateStore } from '@/components/interactions/cart/add-to-cart/add-to-cart-process-state-store'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { HlAppMode } from '@/models/hl-app/hl-app-mode'
import { AddToCartButtonEligibilityCheckerBuilder } from '@spa/components/organisms/mypage/order/model/add-to-cart-button'
import Vue from 'vue'

export interface AddToCartButtonDependency {
  processStateStore: AddToCartProcessStateStore
  eligibilityCheckerBuilder: AddToCartButtonEligibilityCheckerBuilder
}

export const createAddToCartButtonDependency = (): AddToCartButtonDependency => ({
  // stateの変化がリアクティブにvueに伝わるようにする
  processStateStore: Vue.observable(AddToCartProcessStateStore.init()),
  eligibilityCheckerBuilder: AddToCartButtonEligibilityCheckerBuilder.create({
    behavior: BehaviorConfig.forHost,
    hlAppMode: HlAppMode,
  }),
})
